import { render } from "./modal_telephonelie_resto.vue?vue&type=template&id=b5ed86b4&scoped=true"
import script from "./modal_telephonelie_resto.vue?vue&type=script&lang=js"
export * from "./modal_telephonelie_resto.vue?vue&type=script&lang=js"

import "./modal_telephonelie_resto.vue?vue&type=style&index=0&id=b5ed86b4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ed86b4"]])

export default __exports__